import { BigNumber } from "ethers"

export function etherToFloat(priceInEther: string) {
  return parseInt(BigNumber.from(priceInEther).toString()) / 1e18
}
